module.exports = __webpack_public_path__ + "img/Carte-virtuelle-uba.ac62bfa9.png";